import React from 'react'
import { observer } from 'mobx-react-lite'
import { SMSMessageField } from 'widgets/MessageFormFields'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'

export const BroadcastSMS = observer(() => {
  const { broadcastSMSStore, errorsMap, setDraggingCondition } = useBroadcastViewContext()
  const smsMessageError = errorsMap.get('smsMessage')

  return (
    <SMSMessageField
      smsMessageFieldStore={broadcastSMSStore.smsMessageFieldStore}
      errorMessage={smsMessageError}
      setDraggingCondition={setDraggingCondition}
    />
  )
})
